import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { gameAPI } from '../../services/api';
import { useTelegram } from '../../hooks/useTelegram';
import GameCard from '../../components/GameCard/GameCard';

const Page = styled.div`
  min-height: 100vh;
  background: #000;
  padding: 8px 16px;
  padding-bottom: 70px;
  font-family: 'GT Eesti', -apple-system, sans-serif;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 16px 0;
`;

const Description = styled.p`
  font-size: 14px;
  color: rgba(255,255,255,0.6);
  margin: 0 0 20px 0;
  line-height: 1.4;
`;

const GameGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  margin-top: 16px;
`;

const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 16px;
  color: rgba(255,255,255,0.5);
`;

const ErrorMessage = styled.div`
  text-align: center;
  color: #ff3b30;
  padding: 20px;
  font-size: 14px;
`;

const Preorders = () => {
  const navigate = useNavigate();
  const { tg, hapticFeedback } = useTelegram();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const goBack = () => navigate('/');
    if (tg) {
      tg.setHeaderColor('#000000');
      tg.BackButton.show();
      tg.BackButton.onClick(goBack);
    }

    // Fetch preorders from API
    gameAPI.getPreorders()
      .then(preorders => {
        setGames(preorders);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load preorders:', err);
        setError('Не удалось загрузить предзаказы');
        setLoading(false);
      });

    return () => {
      if (tg) {
        tg.BackButton.offClick(goBack);
        tg.BackButton.hide();
      }
    };
  }, [tg, navigate]);

  if (loading) {
    return (
      <Page>
        <Title>🔮 Предзаказы</Title>
        <Loading>Загружаем предзаказы...</Loading>
      </Page>
    );
  }

  if (error) {
    return (
      <Page>
        <Title>🔮 Предзаказы</Title>
        <ErrorMessage>{error}</ErrorMessage>
      </Page>
    );
  }

  return (
    <Page>
      <Title>🔮 Предзаказы</Title>
      <Description>
        Самые ожидаемые игры! Оформите предзаказ и получите игру в день выхода.
      </Description>
      
      {games.length > 0 ? (
        <GameGrid>
          {games.map(game => (
            <GameCard 
              key={game.sony_id || game.id} 
              game={game} 
              onClick={() => {
                hapticFeedback?.('light');
                navigate(`/game/${game.sony_id || game.id}`);
              }}
            />
          ))}
        </GameGrid>
      ) : (
        <Loading>Нет доступных предзаказов</Loading>
      )}
    </Page>
  );
};

export default Preorders;